import { Button } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import { ComponentProps, FC, PropsWithChildren } from 'react'

const StyledButton = styled(Button)`
  width: max-content;
  margin-right: 20px;
  z-index: 10;
  background-color: ${({ theme }) => theme.palette.orange};
  border: none;

  &:hover {
    color: ${({ theme }) => theme.palette.lmcPink};
  }
`

const StyledButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
`

const StyledStepIndicator = styled(Text)`
  color: ${({ theme }) => theme.palette.darkpurple};
  margin-left: 20px;
  font-weight: 800;
`

export const OnboardingButton: FC<ComponentProps<typeof Button>> = (props) => (
  <StyledButton {...props} />
)

export const OnboardingButtonWrapper: FC<PropsWithChildren> = ({
  children
}) => <StyledButtonWrapper>{children}</StyledButtonWrapper>

export const OnboardingStepIndicator: FC<ComponentProps<typeof Text>> = (
  props
) => <StyledStepIndicator {...props} />
